// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import China from '../_raw/flag/icon_flag_china.png';

export default () => <img src={China} alt="China" />;
